import { create } from 'zustand'

/**
 * Stocke les CryptoKey non-extractibles des coffres déverrouillés,
 * et leurs timestamps d'ouverture/activité. Le master password en clair n'est
 * jamais stocké ici ; passwordKey sert uniquement à dériver les clés sensibles
 * avec les sels propres aux entries.
 *
 * { [vaultUuid]: { aesKey: CryptoKey, passwordKey: CryptoKey, unlockedAt: number, lastActivityAt: number } }
 */
export const useVaultStore = create((set, get) => ({
  unlocked: {},
  selectedVaultUuid: null,

  unlock: (vaultUuid, secrets, passwordKey) => {
    const aesKey = secrets?.aesKey ?? secrets
    const nextPasswordKey = secrets?.passwordKey ?? passwordKey ?? null
    return set((state) => ({
      unlocked: {
        ...state.unlocked,
        [vaultUuid]: { aesKey, passwordKey: nextPasswordKey, unlockedAt: Date.now(), lastActivityAt: Date.now() },
      },
    }))
  },

  lock: (vaultUuid) =>
    set((state) => {
      const next = { ...state.unlocked }
      delete next[vaultUuid]
      return { unlocked: next }
    }),

  lockAll: () => set({ unlocked: {} }),

  touch: (vaultUuid) =>
    set((state) => {
      const v = state.unlocked[vaultUuid]
      if (!v) return state
      return { unlocked: { ...state.unlocked, [vaultUuid]: { ...v, lastActivityAt: Date.now() } } }
    }),

  isUnlocked: (vaultUuid) => Boolean(get().unlocked[vaultUuid]?.aesKey),
  getKey: (vaultUuid) => get().unlocked[vaultUuid]?.aesKey ?? null,
  getPasswordKey: (vaultUuid) => get().unlocked[vaultUuid]?.passwordKey ?? null,

  setSelected: (uuid) => set({ selectedVaultUuid: uuid }),
}))
